import { useContext } from 'react';
import Button from '../../../../components/Button';
import {
    CLAIM_CREATOR_FEES_PENDING,
    CREATOR_FEES_CLAIMED,
} from '../../../../config/constants';
import appContext from '../../../../context/app/appContext';
import errorContext from '../../../../context/error/errorContext';
import modalContext from '../../../../context/modal/modalContext';
import { formatUSD } from '../../../../helpers/formats';
import useSpoolsCreatedByUser from '../../../../hooks/web3/app/useSpoolsCreatedByUser';
import useClaimableCreatorFees from '../../../../hooks/web3/vault/useClaimableCreatorFees';

const CreatorFeesClaimable: React.FC = () => {
    const { claimableCreatorFees } = useClaimableCreatorFees();
    const { spoolsCreatedByUser } = useSpoolsCreatedByUser();

    const { openModal, setModalData, closeModal } = useContext(modalContext);
    const { setError } = useContext(errorContext);

    const { interfaceSDK } = useContext(appContext);

    const claimFee = async () => {
        try {
            if (!spoolsCreatedByUser) return;
            setModalData((prev) => ({ ...prev, message: CLAIM_CREATOR_FEES_PENDING }));
            openModal('waitingModal');

            const feeHandler = interfaceSDK!.get.getFeeHandlerContractInstance();

            const assets = spoolsCreatedByUser.reduce(
                (totalAssets, { asset: { id } }) => {
                    return totalAssets.includes(id) ? totalAssets : [...totalAssets, id];
                },
                [] as string[]
            );

            const claim = await feeHandler.collectFees(assets);

            const receipt = await claim.wait();

            setModalData((prev) => ({
                ...prev,
                status: CREATOR_FEES_CLAIMED,
                message: '',
                txHash: receipt.transactionHash,
            }));
            openModal('successModal');
        } catch (error) {
            setError(error);
        } finally {
            closeModal('waitingModal');
        }
    };

    return (
        <div className='fees-container'>
            <div className='fees-claimable'>
                <div className='title'>
                    Total Fees Claimable from All <br /> Creations
                </div>
                <div className='amount'>
                    <span>~${formatUSD(claimableCreatorFees?.total || 0)}</span>
                    {/* <InfoPopUp>
                        <div className='bold'>Includes:</div>
                        <div className='claimable'>
                            <div>Total claimable earnings:</div>
                            <div className='bold'>~$540,721.16</div>
                        </div>
                        <div className='claimable'>
                            <div>Total Incentivized earnings:</div>
                            <div className='bold'>~$143,658.46</div>
                        </div>
                        <div className='tokens'>
                            <div>(124.1235 SPOOL)</div>
                            <div>(1235.123 CRV)</div>
                        </div>
                    </InfoPopUp> */}
                </div>
            </div>
            {/* <div className='fees-earned'>
                <div className='title'>
                    Estimated Fees Earned
                    <br />
                    (Awaiting User Redemption)
                </div>
                <div className='amount'>
                    <span>~${formatUSD(25614.88 || 0)}</span>

                    <InfoPopUp>
                        Includes Estimated Fees from Created Spools and Risk Models. These
                        earnings will become claimable as users withdraw their positions
                        from their active Spools.
                    </InfoPopUp>
                </div>
            </div> */}
            <Button
                onClick={claimFee}
                disabled={
                    (claimableCreatorFees ? !+claimableCreatorFees?.total : true) ||
                    !spoolsCreatedByUser?.length
                }
            >
                Claim All Fees
            </Button>
        </div>
    );
};

export default CreatorFeesClaimable;
